import { useMutation } from '@tanstack/react-query';
import { registerToLiveClass } from '../../queries/LiveClasses';

export function useRegisterToLiveClass() {
  const { data, isError, error, isSuccess, isPending, mutate, mutateAsync } =
    useMutation({
      mutationKey: ['live-class-registration'],
      mutationFn: (eventId: string) => registerToLiveClass(eventId),
      retry: false
    });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
    mutate,
    mutateAsync,
  };
}
